<template>
    <LoadingCard v-if="loading" />
    <div v-else>
        <div class="card">
            <div class="card-header bg-primary text-white">
                Contractors
            </div>
            <b-table small hover stacked="md" :items="allContractors" :fields="table.fields" sort-by="name" :show-empty="true"
                     @row-clicked="toggleRow">
                <template slot="name" slot-scope="row">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" :id="`contractor${row.item.id}`" type="checkbox" :checked="isLinked(row.item.id)">
                        <label class="custom-control-label" :for="`contractor${row.item.id}`">{{ row.item.name }}</label>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import createLinkMutation from '@views/Blocks/ContractorManager/mutationCreateBlockContractorLink.graphql';
import deleteLinkMutation from '@views/Blocks/ContractorManager/mutationDeleteBlockContractorLink.graphql';
import listBlockLinkedContractorsQuery from '@views/Blocks/ContractorManager/queryListBlockLinkedContractors.graphql';
import listGrowerLinkedContractorsQuery from '@views/Blocks/ContractorManager/queryListGrowerLinkedContractors.graphql';

/**
 * @property {String} searchTerm
 */
export default {
  name: 'ContractorManager',
  props: ['block'],
  apollo: {
    allContractors: {
      query: listGrowerLinkedContractorsQuery,
      update: data => data.filterGrowerContractorLinks,
    },
    linkedContractors: {
      query: listBlockLinkedContractorsQuery,
      variables() {
        return {
          input: {
            block_id: [this.block.id],
          },
        };
      },
      update: data => data.filterContractorBlockLinks,
    },
  },
  data() {
    return {
      allContractors: [],
      linkedContractors: [],
      loading: 0,
    };
  },
  computed: {
    table() {
      return {
        fields: [{ key: 'name', label: 'Contractor', sortable: true }],
      };
    },
  },
  mounted() {
  },
  methods: {
    isLinked(contractorId) {
      return this.linkedContractors.some(
        link => link.user_id === contractorId);
    },
    toggleRow(item, index, event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isLinked(item.id)) {
        this.unlinkContractor(item);
      } else {
        this.linkContractor(item);
      }
    },
    unlinkContractor(contractor) {
      const linkToRemove = this.linkedContractors.find(link => link.user_id === contractor.id);

      this.$apollo.mutate({
        mutation: deleteLinkMutation,
        variables: {
          input: {
            user_id: linkToRemove.user_id,
            block_id: linkToRemove.block_id,
          },
        },
        update: (
          store,
          { data: { deleteContractorBlockLink: removedLink } },
        ) => {
          const queryKey = {
            query: listBlockLinkedContractorsQuery,
            variables: {
              input: {
                block_id: [this.block.id],
              },
            },
          };
          const data = store.readQuery(queryKey);
          const indexToRemove = data.filterContractorBlockLinks.findIndex(
            item => item.user_id === removedLink.user_id,
          );
          if (indexToRemove !== -1) {
            data.filterContractorBlockLinks.splice(indexToRemove, 1);
            store.writeQuery({
              ...queryKey,
              data,
            });
          }
        },
        optimisticResponse: {
          __typename: 'Mutation',
          deleteContractorBlockLink: {
            ...linkToRemove,
          },
        },
      });
    },
    linkContractor(contractor) {
      this.$apollo.mutate({
        mutation: createLinkMutation,
        variables: {
          input: {
            user_id: contractor.id,
            block_id: this.block.id,
          },
        },
        update: (
          store,
          { data: { createContractorBlockLink: link } },
        ) => {
          const queryKey = {
            query: listBlockLinkedContractorsQuery,
            variables: {
              input: {
                block_id: [this.block.id],
              },
            },
          };
          const data = store.readQuery(queryKey);
          data.filterContractorBlockLinks.push(link);
          store.writeQuery({ ...queryKey, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          createContractorBlockLink: {
            __typename: 'ContractorBlockLink',
            user_id: contractor.id,
            block_id: this.block.id,
          },
        },
      });
    },
  },
};
</script>
